import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ViewChild, TemplateRef } from '@angular/core';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours, } from 'date-fns';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { Subject } from 'rxjs';
declare var $: any;
declare var jQuery: any;
import * as moment from 'moment'

import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};
@Component({
  selector: 'app-buytickets',
  templateUrl: './buytickets.component.html',
  styleUrls: ['./buytickets.component.scss']
})
export class BuyticketsComponent implements OnInit {

  seasonList: any = "";
  seasontypeList: any = "";
  matchesList: any = "";
  main_tabid = 1;
  seasontype: any = 0;
  membershipList: any = "";
  status: any = "Upcoming";
  matchesrequest: any = {
    series_type_id: this.main_tabid,
    matche_status: this.status
  };

  dateList: any = [];
  next_btn: boolean = true;
  matchvalue: any = 0;
  total: any = 0;
  first_name: any;
  first_image: any;
  date_time: any;
  second_name: any;
  second_image: any;
  startdate: any = [];

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        //this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [
    {
      start: subDays(startOfDay(this.startdate), 1),
      end: addDays(this.startdate, 1),
      title: 'A 3 day event',
      color: colors.red,
      actions: this.actions,
      allDay: true,
      resizable: {
        beforeStart: true,
        afterEnd: true,
      },
      draggable: true,
    },
    {
      start: startOfDay(new Date()),
      title: 'An event with no end date',
      color: colors.yellow,
      actions: this.actions,
    },
    {
      start: subDays(endOfMonth(new Date()), 3),
      end: addDays(endOfMonth(new Date()), 3),
      title: 'A long event that spans 2 months',
      color: colors.blue,
      allDay: true,
    },
    {
      start: addHours(startOfDay(new Date()), 2),
      end: addHours(new Date(), 2),
      title: 'A draggable and resizable event',
      color: colors.yellow,
      actions: this.actions,
      resizable: {
        beforeStart: true,
        afterEnd: true,
      },
      draggable: true,
    },
  ];

  activeDayIsOpen: boolean = true;


  constructor(private allpagesService: AllPageService,) { }
  slidematchbookConfig = {
    //dots: true,
    infinite: true,
    arrows: true,
    slidesToShow: 2,
    autoplay: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  slidematchreportConfig = {
    //dots: true,
    infinite: true,
    arrows: true,
    slidesToShow: 2,
    autoplay: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  ngOnInit() {
    this.loadmatches();
    this.allpagesService.getSeasontype().then((data) => {
      this.seasonList = data;
      this.seasontypeList = data.data[this.seasontype];
      //console.log(this.seasonList);
      setTimeout(() => {
        jQuery(".courses-name").click(function () {
          if (jQuery(this).hasClass('active')) {
            // do nothing
          } else {
            var tabid = jQuery(this).attr('id');
            jQuery(".courses-name").removeClass('active');
            jQuery(this).addClass('active');
            jQuery(".course-main-content").removeClass('active');
            jQuery("#" + tabid + "-content").addClass("active");
            jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-name:first").addClass("ok");
            jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-main-content:first").addClass("ok");
          }
          return false;
        });
        jQuery(".fixtures-name").click(function () {
          if (jQuery(this).hasClass('ok')) {
            // do nothing
          } else {
            var tabid = jQuery(this).attr('id');
            jQuery(".fixtures-name").removeClass('ok');
            jQuery(this).addClass('ok');
            jQuery(".fixtures-main-content").removeClass('ok');
            jQuery("#" + tabid + "-content").addClass("ok");
          }
          return false;
        });
        jQuery('.select_tab').click((e) => {
          var dataseason = e.currentTarget.value;
          this.seasontype = dataseason - 1;
          console.warn(dataseason);
          console.log(this.seasontype);
          this.seasontypeList = data.data[this.seasontype];
          console.warn(this.seasontypeList);
        });
        jQuery('ul.maintab li a').click((e) => {
          var dataid = e.currentTarget.id;
          this.main_tabid = dataid;
          this.matchesrequest = {
            series_type_id: this.main_tabid,
            matche_status: this.status
          };
          this.loadmatches();
        });

        jQuery('ul.subtab li a').click((e) => {
          var datastatus = e.currentTarget.id;
          this.status = datastatus;
          this.matchesrequest = {
            series_type_id: this.main_tabid,
            matche_status: this.status
          };
          this.loadmatches();
        });
        this.slidematchbookConfig = {
          //dots: true,
          infinite: true,
          arrows: true,
          slidesToShow: 2,
          autoplay: false,
          speed: 500,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        };
      }, 1000);

      this.slidematchreportConfig = {
        //dots: true,
        infinite: true,
        arrows: true,
        slidesToShow: 2,
        autoplay: false,
        speed: 500,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };
    });

    // jQuery(".courses-name").click(function(){
    //   if(jQuery(this).hasClass('active')){
    //     // do nothing
    //   }else{
    //     var tabid = jQuery(this).attr('id');
    //     jQuery(".courses-name").removeClass('active');
    //     jQuery(this).addClass('active');
    //     jQuery(".course-main-content").removeClass('active');
    //     jQuery("#"+tabid+"-content").addClass("active");
    //     jQuery("#" + tabid + "-content").find(".fixtures-name:first").addClass("active");
    // 		jQuery("#" + tabid + "-content").find(".fixtures-main-content:first").addClass("active");
    //   }
    //   return false;
    // });
    // jQuery(".fixtures-name").click(function(){
    // if(jQuery(this).hasClass('active')){
    //   // do nothing
    //   }else{
    //     var tabid = jQuery(this).attr('id');
    //       jQuery(".fixtures-name").removeClass('active');
    //       jQuery(this).addClass('active');
    //       jQuery(".fixtures-main-content").removeClass('active');
    //       jQuery("#"+tabid+"-content").addClass("active");
    //     }
    //   return false;
    // });
    // jQuery(".fixture-season-detail a.season-top").click(function(){
    //   jQuery(".fixture-season-detail").toggleClass("open");
    //   return false;
    // });
    // jQuery(".fixture-season-detail ul.fixture-season-list li ").click(function(){
    //   jQuery(".fixture-season-detail").removeClass("open");
    //   return false;
    // });
  }

  loadmatches() {
    //console.log(this.main_tabid);
    //console.log(this.status);
    let request = Object.assign({}, this.matchesrequest);
    this.allpagesService.getMatcheslist(request).then((data: any) => {
      this.matchesList = data;
     // console.log(this.matchesList);
    });
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    //this.modal.open(this.modalContent, { size: 'lg' });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }


}
